import { lazy } from 'react'

export const CatchOnALieVariant1 = lazy(() => import('./CatchOnALieVariant1'))
export const CatchOnALieVariant2 = lazy(() => import('./CatchOnALieVariant2'))
